<template>
    <Select v-model="model1" @on-change="selectItem" style="width:80px">
        <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
</template>
<script>
    export default {
        name: "UserFeatureSingleSelect",
        data () {
            return {
                cityList: [
                    {
                        value: 'new_add',
                        label: '新增'
                    },
                    {
                        value: 'active',
                        label: '活跃'
                    },
                    {
                        value: 'consume',
                        label: '消费'
                    }
                ],
                model1: 'new_add'
            }
        },
        methods:{
            selectItem(event) {
                this.$emit("transmit", this.model1)
            },
        }
    }
</script>
